export const CURRENCY_DECIMAL_PLACES = 6;
export const COURIER_MARKUP_DECIMAL_PLACES = 4;
export const MIN_DECIMAL_PLACES = 2;
export const MAX_TOTAL_MARGIN = 0.99; // +99% cap
export const MIN_TOTAL_MARGIN = -0.1; // -10% cap
export const MAX_MARKUP_DOLLARS = 1000; // +$1000 max
export const MIN_MARKUP_DOLLARS = -10; // -$10 max

// Stripe card-processing pass-through for Credit Card and Wallet billing (Machool Account pays neither).
// Source of truth for app-services (company margins) and integration-services (rating tool).
export const STRIPE_FEE = 3.2; // +3.2% added to fullPricingMargin
export const STRIPE_FLAT_FEE = 0.35; // +$0.35 added to the base, before tax

export const PROVINCIAL_DESTINATION_TAX_RATES: {
  [key: string]: { code: string; value: number }[];
} = {
  AB: [{ code: 'GST', value: 5 }],
  BC: [{ code: 'GST', value: 5 }],
  MB: [{ code: 'GST', value: 5 }],
  NB: [{ code: 'HST', value: 15 }],
  NL: [{ code: 'HST', value: 15 }],
  NS: [{ code: 'HST', value: 14 }],
  NT: [{ code: 'GST', value: 5 }],
  NU: [{ code: 'GST', value: 5 }],
  ON: [{ code: 'HST', value: 13 }],
  PE: [{ code: 'HST', value: 15 }],
  QC: [
    { code: 'GST', value: 5 },
    { code: 'PSTQST', value: 9.975 },
  ],
  SK: [{ code: 'GST', value: 5 }],
  YT: [{ code: 'GST', value: 5 }],
};

export const PROVINCIAL_SERVICE_TAX_RATES: {
  [key: string]: { code: string; value: number }[];
} = {
  AB: [{ code: 'GST', value: 5 }],
  BC: [
    { code: 'PST', value: 7 },
    { code: 'GST', value: 5 },
  ],
  MB: [
    { code: 'PST', value: 7 },
    { code: 'GST', value: 5 },
  ],
  NB: [{ code: 'HST', value: 15 }],
  NL: [{ code: 'HST', value: 15 }],
  NS: [{ code: 'HST', value: 14 }],
  NT: [{ code: 'GST', value: 5 }],
  NU: [{ code: 'GST', value: 5 }],
  ON: [{ code: 'HST', value: 13 }],
  PE: [{ code: 'HST', value: 15 }],
  QC: [
    { code: 'GST', value: 5 },
    { code: 'PSTQST', value: 9.975 },
  ],
  SK: [
    { code: 'PST', value: 6 },
    { code: 'GST', value: 5 },
  ],
  YT: [{ code: 'GST', value: 5 }],
};

export const CourierMachoolDiscounts: any = {
  gls: {
    base: 0.0,
    items: {
      FUS: 0.0,
    },
  },
  dhl: {
    base: 0.7,
    items: {
      FF: 0.7,
    },
  },
  purolator: {
    base: 0.7,
    items: {
      Fuel: 0.0,
    },
  },
};

export enum FuelSurchargeRule {
  PERCENT = 'PERCENT',
  PER_KILO = 'PER_KILO',
  PER_POUND = 'PER_POUND',
}
